import React from "react";
import fb from '../../lib/firebase';
import {post} from '../../utils/frRequest';
import {
  IonHeader, IonTitle, IonToolbar, IonContent,
  IonMenuButton, IonButtons, IonPage, IonProgressBar, IonLabel, IonInput, IonItem,
} from "@ionic/react";
import {FormDefinition, FormState} from "../../lib/forms";
import {
  ModelForm,
  ModelFormProps,
  buildModelForm,
  ModelFormField
} from "../../components/ModelFormHOC";
import {connect} from "react-redux";
import {AppDispatch, RootState} from "../../global.state";
import {AppState} from "../../models/app";
import {actions} from "../../lib/app";
import ExcluirContaButton from "./ExcluirContaButton";

interface Props extends ModelFormProps {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loadingEstados: boolean;
  loadingRegionais: boolean;
  estados: any[];
  regionais: any[],
  loadingCidades: boolean;
  cidades: any[];
  loadingGestores: boolean;
  gestores: any[];

  estado: string | undefined;
  regional: string | undefined;
}

const formDef: FormDefinition = {
  nome: {name: 'nome', label: 'Nome', type: "string", required: true},
  telefone: {name: 'telefone', label: 'Telefone', type: "telefone", required: true},
  estado: {name: 'estado', label: 'Estado', type: "searchInput", required: true},
  cidade: {name: 'cidade', label: 'Cidade', type: "searchInput", required: true},
  regional: {name: 'regional', label: 'Regional', type: "select", required: true},
  gestor_uid: {name: 'gestor_uid', label: 'Gestor responsável', type: "select", required: false},
};

class Cadastro extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loadingEstados: false,
      loadingCidades: false,
      loadingRegionais: false,
      loadingGestores: false,
      estados: [],
      cidades: [],
      regionais: [],
      gestores: [],
      estado: undefined,
      regional: undefined,
    };
  }

  // noinspection DuplicatedCode
  componentDidMount() {
    this.loadEstados();
    this.loadRegionais();

    if (this.props.app.user.hasProfile && this.props.app.user.estado) {
      this.loadCidades(this.props.app.user.estado);
      this.setState({estado: this.props.app.user.estado});
    }

    if (this.props.app.user.hasProfile && this.props.app.user.regional) {
      this.loadGestores(this.props.app.user.regional);
      this.setState({regional: this.props.app.user.regional});
    }
  }

  loadEstados() {
    this.setState({loadingEstados: true}, () => {
      fb.db.collection('estados').get()
        .then(res => this.setState({estados: fb.col(res), loadingEstados: false}))
        .catch(() => this.setState({loadingEstados: false}));
    });
  }

  loadRegionais() {
    this.setState({loadingRegionais: true}, () => {
      fb.db.collection('regionais').orderBy('label', 'asc').get()
        .then(res => this.setState({regionais: fb.col(res), loadingRegionais: false}))
        .catch(() => this.setState({loadingRegionais: false}));
    });
  }

  loadCidades(estado: string) {
    if (this.state.loadingCidades)
      return;

    this.setState({loadingCidades: true}, () => {
      fb.db.collection('cidades').where('estado', '==', estado).get()
        .then(snap => {
          const cidades = fb.col(snap);
          // nocache
          if (!this.props.app.online && !cidades.length)
            this.props.dispatch(actions.notifyError(`As cidades do estado ${estado} não estão disponíveis offline ainda!`));
          this.setState({cidades, loadingCidades: false})
        })
        .catch(() => this.setState({loadingCidades: false}));
    });
  }

  loadGestores(regional: string) {
    if (this.state.loadingGestores)
      return;

    this.setState({loadingGestores: true}, () => {
      post('/veApi/transferencias/listar_gestores', {regional})
        .then(res => {
          const gestores = res.success ? (res.data as {gestores: any[]}).gestores : [];
          this.setState({gestores, loadingGestores: false});
        })
        .catch(() => this.setState({loadingGestores: false}));
    });
  }

  onCreate = () => {
    throw Error("Invalid call, profile should only be updated, never created.")
  };

  onUpdate = (values:any) => {
    if (this.props.app.user.hasProfile) {
      return fb.document.update('users', this.props.app.user.uid, values);
    } else {
      return fb.document.create('users', values, this.props.app.user.uid);
    }
  };

  onComplete = () => {
    this.props.dispatch(actions.reloadProfile());
    this.props.history.replace('/home');
  };

  onChangeEstado = (value:any, state:FormState) => {
    this.setState({estado: value}, () => {
      if (value && state.estado.value !== value)
        this.loadCidades(value);
    });
  };

  onChangeRegional = (value:any, state:FormState) => {
    this.setState({regional: value}, () => {
      if (value && state.regional.value !== value)
        this.loadGestores(value);
    });
  };

  onCompleteExcluirConta = () => {

  }

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>
              {
                this.props.app.user.hasProfile ?
                  'Dados pessoais' : 'Primeiro acesso'
              }
            </IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {
            !this.props.app.user.loaded ?
              <IonProgressBar type="indeterminate"/> :
              <>
                <div className="text-xl">
                  Bem vindo ao Vet Experts Virbac
                </div>
                {
                  this.props.app.user.hasProfile ?
                    <div className="text-gray-700">
                      Mantenha seus dados atualizados.
                    </div>
                    :
                    <div>
                      Complete seu cadastro abaixo antes de iniciar o uso do aplicativo.
                    </div>
                }

                <ModelForm
                  entityLabel="Cadastro"
                  ownerId={this.props.app.user.uid}
                  gender="m"
                  instance={this.props.app.user}
                  formDefinition={formDef}
                  onCreate={this.onCreate}
                  onUpdate={this.onUpdate}
                  onComplete={this.onComplete}
                >
                  <ModelFormField field="nome"/>
                  <ModelFormField field="telefone"/>
                  <ModelFormField
                    field="estado"
                    options={this.state.estados}
                    optionLabel="uf"
                    optionValue="uf"
                    loading={this.state.loadingEstados}
                    disabled={this.state.loadingEstados}
                    onChange={this.onChangeEstado}
                  />
                  <ModelFormField
                    field="cidade"
                    options={this.state.cidades}
                    optionLabel="nome"
                    optionValue="nome"
                    loading={this.state.loadingCidades}
                    disabled={
                      (!this.state.estado) || this.state.loadingCidades
                    }
                    interfaceOptions="app-select-alert wide"
                  />
                  <IonItem>
                    <IonLabel position={'floating'}>
                      Email
                    </IonLabel>
                    <IonInput
                      value={this.props.app.user.email}
                      disabled={true}
                    />
                  </IonItem>

                  <ModelFormField
                    field="regional"
                    options={this.state.regionais}
                    optionLabel="label"
                    optionValue="id"
                    loading={this.state.loadingRegionais}
                    disabled={this.state.loadingRegionais}
                    onChange={this.onChangeRegional}
                  />
                  <ModelFormField
                    field="gestor_uid"
                    options={this.state.gestores}
                    optionLabel="nome"
                    optionValue="uid"
                    loading={this.state.loadingGestores}
                    disabled={(!this.state.regional) || this.state.loadingGestores}
                  />
                </ModelForm>

                {this.props.app.user.hasProfile && !this.props.app.user.regional &&
                  <div className="mt-4 bg-red-200 rounded p-2 text-center">
                    Você precisa completar o cadastro antes de usar o aplicativo.
                  </div>
                }

                {this.props.app.user.hasProfile &&
                  <div className="mt-8 w-full flex justify-center">
                    <ExcluirContaButton
                      mensagem="Solicitado diretamente via Meu cadastro"
                    />
                  </div>
                }
              </>
          }
        </IonContent>
      </IonPage>
    );
  }
}

const CadastroHOC = buildModelForm(Cadastro);
export default connect(({app}: RootState) => ({app}))(CadastroHOC);
